import { forwardRef } from "react";
import { Link, NavLink, type LinkProps, type NavLinkProps } from "react-router-dom";
import { useLocale } from "@/i18n/LocaleProvider";

/** A <Link> that automatically prefixes the `to` path with the current locale. */
export const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...rest }, ref) => {
    const { toLocalePath } = useLocale();
    const next = typeof to === "string" ? toLocalePath(to) : to;
    return <Link ref={ref} to={next} {...rest} />;
  }
);
LocaleLink.displayName = "LocaleLink";

export const LocaleNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ to, ...rest }, ref) => {
    const { toLocalePath } = useLocale();
    const next = typeof to === "string" ? toLocalePath(to) : to;
    return <NavLink ref={ref} to={next} {...rest} />;
  }
);
LocaleNavLink.displayName = "LocaleNavLink";
